'use client'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import { IoSunnyOutline } from 'react-icons/io5'
import { LuTrees } from 'react-icons/lu'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'


export default function RegisterIntroSection({ sliderImages, callToAction }: {sliderImages: string[], callToAction: string}) {
	return (
		<div id='register' className='relative bg-white py-16 overflow-hidden'>
			<LuTrees className="absolute bottom-[-20px] left-[-60px] w-48 h-48 sm:w-72 sm:h-72 text-mountain-900 opacity-10 pointer-events-none z-0" />
			<IoSunnyOutline className="absolute top-[-40px] right-[-60px] w-48 h-48 sm:w-72 sm:h-72 text-mountain-900 opacity-10 pointer-events-none z-0" />

			<div className='flex flex-col md:flex-row lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto justify-between items-center gap-10 md:gap-16 px-6 relative z-10'>

				<div className='flex flex-col md:items-start items-center md:w-1/2 text-center md:text-left bg-white/5 backdrop-blur-sm p-4 rounded-xl md:bg-transparent md:backdrop-blur-0'>
					<h1 className="text-4xl lg:text-5xl drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 mb-12 uppercase text-center">
						Зусланд амрах уу?
					</h1>
					<p className=' text-lg sm:text-xl lg:text-2xl leading-relaxed max-w-[550px]'>
						<span dangerouslySetInnerHTML={{ __html: callToAction }} />
					</p>
				</div>

				<div className="relative w-full md:w-1/2">
					<Swiper
						modules={[Navigation]}
						navigation={{
							nextEl: '.swiper-next',
							prevEl: '.swiper-prev',
						}}
						loop={true}
						className="rounded-2xl overflow-hidden shadow-2xl"
					>	

						{sliderImages && sliderImages.map((image, index) => (
							<SwiperSlide key={index}>
								<img src={image} className="w-full aspect-[16/10] object-cover" alt={`Camp ${index + 1}`} />
							</SwiperSlide>
						))}

						<div className="left-3 swiper-prev absolute top-1/2 -translate-y-1/2 z-10 p-3 bg-white/30 hover:bg-white/50 rounded-full backdrop-blur-md cursor-pointer select-none">
							<FaChevronLeft className='text-white' />
						</div>
						<div className="right-3 swiper-next absolute top-1/2 -translate-y-1/2 z-10 p-3 bg-white/30 hover:bg-white/50 rounded-full backdrop-blur-md cursor-pointer select-none">
							<FaChevronRight className='text-white' />
						</div>
					</Swiper>
				</div>
			</div>
		</div>
	)
}
